import dynamic from "next/dynamic";
import React from "react";

import { useUserContext } from "@/features/user/contexts/useUserContext";

const Placeholder = dynamic(
  () => import("./SiteTopNavigationUserCredentialPlaceholder"),
  { ssr: false },
);

const LoginRegisterButton = dynamic(
  () => import("@/features/auth/LoginCreateAnAccountButtons"),
  { ssr: false },
);

const AvatarMenu = dynamic(() => import("./DesktopHeaderActions"), {
  ssr: false,
});

export const SiteTopNavigationUserCredentialView = () => {
  const { user, ready } = useUserContext();

  if (!ready) {
    return <Placeholder />;
  }

  if (ready && !user) {
    return <LoginRegisterButton />;
  }

  return <AvatarMenu />;
};
